module.exports = "<div class=\"breadcrumb-section bg-mid-grey section\">\n    <div class=\"breadcrumb-inner\">\n        <ul class=\"breadcrumbs\">\n            <li><a href=\"#\">Checkout</a></li>\n        </ul>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/breadcrumb/breadcrumb.html
// module id = 131
// module chunks = 0